import { formatTime } from '~/shared';

export function getCurrentDateString() {
	return formatTime(Date.now(), '{MM}-{dd}-{yy}', { useMoscowTimezone: true });
}

/**
 * 1 апреля по московскому времени (с 00:00 до 23:59 МСК)
 */
export function isAprilFoolsDay(date: number = Date.now()): boolean {
	return formatTime(date, '{dd}.{MM}', { useMoscowTimezone: true }) === '01.04';
}

export function formatRelativeTime(date: number): string {
	const dateObj = new Date(date);
	const now = new Date();

	const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
	const yesterday = new Date(today);
	yesterday.setDate(yesterday.getDate() - 1);
	const messageDate = new Date(
		dateObj.getFullYear(),
		dateObj.getMonth(),
		dateObj.getDate(),
	);

	const timeFormatter = new Intl.DateTimeFormat('ru-RU', {
		hour: '2-digit',
		minute: '2-digit',
		hour12: false,
	});

	const dateFormatter = new Intl.DateTimeFormat('ru-RU', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
		hour12: false,
	});

	if (messageDate.getTime() === today.getTime()) {
		return `Сегодня ${timeFormatter.format(date)}`;
	} else if (messageDate.getTime() === yesterday.getTime()) {
		return `Вчера ${timeFormatter.format(date)}`;
	} else {
		return dateFormatter.format(date);
	}
}
